export default "__VITE_ASSET__6a1a3d68__"